import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

export function CourseQuestionHeader({hasAccess, isUser}) {
    const [isActiveOnMenu, setIsActiveOnMenu] = useState(false)

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setIsActiveOnMenu(menuitem === 'faqs')
        }

        document.addEventListener('course_menu_tabs', listener)

        return () => {
            document.removeEventListener('course_menu_tabs', listener)
        }

    }, []);

    if(!isActiveOnMenu) return null;

    const onChangeInput = (event) => {
        const value = event.target.value.toLowerCase();
        const e =  new CustomEvent('course_menu_questions_query', {detail : value})

        document.dispatchEvent(e)
    }

    return(
        <Container>
            <InputText onChange={onChangeInput} type='text' placeholder={'Buscar'} />
            {!hasAccess && (<Caption><Link href={isUser ? '#' : '/buy/page'} >{isUser ? 'Suscríbete' : 'Regístrate'}</Link> para enviar tus preguntas</Caption>)}
        </Container>
    )
}

const InputText = styled.input`
    padding: 8px 12px;
    margin-left: 12px;
    margin-bottom: 12px;
    font-size: 14px;
`

const Container = styled.div`
    padding: 12px;
    display: flex;
    flex-direction: column;
`

const Link = styled.a`
    color: #FA9F63;

`
const Caption =  styled.div`
    color: white;
    font-size: 18px;
    text-align: center;
`

if (document.getElementsByTagName('course-menu-questions-header')) {
    const elms = document.getElementsByTagName('course-menu-questions-header')

    for(let elm of elms) {
        const hasAccess = elm.attributes['has-access'].value === '1'
        const isUser = elm.attributes['is-user'].value === '1'
        ReactDOM.render(<CourseQuestionHeader hasAccess={hasAccess} isUser={isUser} />, elm);
    }
}
